import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { useNavigate } from "react-router-dom";
import MultiSelect from "../../../components/form/select/MultiSelect";
import {
  getAllRoles,
  makeStaffUser,
} from "../../../redux/slice/staff/staffSlice";
import * as Yup from "yup";

const MakeUser = ({ modal_id, user_id, setSelectedUser }) => {
  const { staff_list, roles } = useSelector((state) => state.staff);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);

  const closeRef = useRef();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const handleNavigate = () => {
  //   navigate("/admin/customer-overview");
  // };

  // const handleMakeUser = () => {
  //   const staff_id = {
  //     staff_id: user_id,
  //   };
  //   dispatch(makeStaffUser(staff_id));
  // };

  const onSubmit = ({ roles }) => {
    // const id = {
    //   staff_id: user_id,
    // };
    roles = roles.map((role) => {
      return { role: role.value };
    });
    const payload = { id: user_id, roles: roles };
    dispatch(makeStaffUser(payload));
    closeRef.current.click();
  };

  useEffect(() => {
    setLoading(true);
    const selected_user = staff_list?.data?.filter((f) => f.id === user_id)[0];
    setUser(selected_user);
  }, [user_id]);

  useEffect(() => {
    dispatch(getAllRoles());
  }, [dispatch]);

  const validationScehma = Yup.object().shape({
    roles: Yup.array().min(1),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    setFieldTouched,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      roles: [],
    },
    validationSchema: validationScehma,
    // validate: (values) => {
    //   const errors = {};
    //   if (
    //     (values.role.length === 0)
    //   ) {
    //     errors.role = "At least one specific role is required";
    //   }
    //   return errors;
    // },
    onSubmit,
  });

  useEffect(() => {
    setLoading(false);
  }, [user]);

  return (
    <div
      className='modal fade'
      id={modal_id}
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby='staticBackdropLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog modal-dialog-centere mt-5'>
        <div className='modal-content rounded-4'>
          <div className='modal-body'>
            <div className='container p-2'>
              <div className='d-flex '>
                {/* <QUESTION_ICON/> */}
                <h3 className='text-dark mb-3'>Make User</h3>
                {/* <img className='card-icon' src={SUCCESS_ICON} alt="" /> */}
              </div>
              <div className='w-9 mx-auto text-dark fs-5'>
                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div>
                      <label htmlFor='role' className=''>
                        Full Name
                      </label>
                      <input
                        type='text'
                        name=''
                        id=''
                        defaultValue={`${user?.first_name} ${user?.last_name}`}
                        placeholder=''
                        disabled
                        className='form-control'
                      />
                    </div>
                    <div className='mt-2'>
                      <label htmlFor='role' className=''>
                        Select Role
                      </label>
                      <MultiSelect
                        isError={errors?.roles && values.roles.length < 0}
                        name='roles'
                        field={{ ...getFieldProps("roles") }}
                        data={roles?.roles?.map((item, i) => ({
                          label: item,
                          value: item,
                        }))}
                        onChange={setFieldValue}
                        onBlur={() => {
                          handleBlur({ target: { name: "roles" } });
                        }}
                        errors={errors}
                        touched={touched}
                      />
                    </div>
                    <div className='mt-3'>
                      <div className='d-flex justify-content-between'>
                        <button
                          type='button'
                          ref={closeRef}
                          className=' btn text-dark p-1 px-4 rounded-2 cursor-p'
                          style={{ background: "#e0e0e0" }}
                          data-bs-dismiss='modal'
                        >
                          Cancel
                        </button>
                        <button
                          className='btn btn-primary btn-sm px-4 rounded'
                          type='submit'
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MakeUser;
